import React from 'react';
import { useDispatch } from 'react-redux';
import { titleCase } from 'title-case';
import Close from '../../../../../assets/icons/close.svg';
import { clearActiveSettings } from '../../../../../store/reducers/forms';
import styles from './ModalSettings.module.scss';

const ModalSettings = ({ title, children }) => {
  const dispatch = useDispatch();

  return (
    <div className={styles.wrapper}>
      <div className={styles.settings_title}>{titleCase(title)}</div>
      <div className={`${styles.close}`}>
        <Close
          type="button"
          data-bs-dismiss="modal"
          aria-label="Close"
          onClick={() => dispatch(clearActiveSettings())}
        />
      </div>
      {children}
    </div>
  );
};

export default ModalSettings;
